module.exports = __webpack_public_path__ + "img/trouble.ab9007e1.jpg";